export default __webpack_public_path__ + "media/images/landing-7-550x420-e971ae7b78080b2bbff29fadb15b7fe6.jpg";